/**
 * What the hero says while a recorded pregnancy is still standing.
 *
 * The outcome hero resolves its words from the route, and the route is the same
 * one a beta drawn this morning produces — so a patient six weeks into a
 * pregnancy still read "Take a breath after your IVF transfer / whatever you're
 * feeling, you don't have to decide what comes next today". That copy was written
 * for the hour the result lands. Nothing ever replaced it: the acknowledged stage
 * view reuses the same two strings, so pressing "Let's look at what's next"
 * changed the sections and not a word of the heading.
 *
 * This is the pregnancy's own voice, and it is deliberately warm. It claims no
 * dates: the app does not count weeks from the record alone — see
 * `gestationalAgeVisibility` — so the heading congratulates and then invites her
 * to say where she is, which is the one thing that unlocks the dated steps.
 *
 * Whether it applies at all is not decided here. `shouldShowEarlyPregnancyGuidance`
 * already answers "is there a standing pregnancy, and is this the person who
 * carried the cycle", and the hero asks it once for both this and the guidance
 * section. A birth or a loss takes its own voice ahead of this one.
 */

const I18N_ROOT = "homepage.standing_pregnancy";

export function standingPregnancyCopyKeys(input: {
  /**
   * A partner reads the same hero. The invitation to report where the pregnancy
   * is belongs to the person carrying it, so his body congratulates them both and
   * asks nothing of him.
   */
  viewerIsSupporting: boolean;
}): { titleKey: string; bodyKey: string } {
  return {
    titleKey: `${I18N_ROOT}.congratulations_its_positive`,
    bodyKey: input.viewerIsSupporting
      ? `${I18N_ROOT}.supporting.congratulations_to_you_both`
      : `${I18N_ROOT}.saved_and_tell_us_where_you_are`,
  };
}
